import React, { useEffect, useState } from "react";
import CommonCrypt from "../../Common/CommonCrypt";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import { useParams, Link } from "react-router-dom";
import { Container, Row, Col, Image, Button, Modal } from 'react-bootstrap';
import { MenuClose, Activitiesborder, StarIcon, BtnArrow } from '../../svgIcon';
import "./_event-listing.scss";

function EventCalendar({ PageData, ContactInfo, alias, Constant }) {
    // console.log(Constant);
    const route = useParams();
    const CDN_URL = window.cdn_path;
    const [events, setEvents] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [selectedEvent, setSelectedEvent] = useState(null); // To store clicked event details
    const APP_URL = window.site_url;

    useEffect(() => {
        const fetchEventData = async () => {
            const response = await fetch(APP_URL + '/api/event-calendar', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            const eventsData = await response.json();
            const eventsDataDecrypted = JSON.parse(CommonCrypt(eventsData.events_result));
            const FormattedData = eventsDataDecrypted?.events?.map((value, index) => {
                let WebpImage = '';
                if (value?.varWebpImgURL) {
                    WebpImage = CDN_URL + 'caches/' + Constant?.EVENTCALENDERTHUMB?.split(',')[0].replace('*', 'x') + '/' + value?.varWebpImgURL;
                } else {
                    WebpImage = CDN_URL + 'assets/images/' + value?.varImgURL;
                }
                return {
                    id: value?.id,
                    title: value?.varTitle,
                    start: value?.dtDateTime,
                    end: value?.dtEndDateTime,
                    description: value?.varDescription,
                    short_description: value?.varShortDescription,
                    alias: value?.alias?.varAlias,
                    image: WebpImage
                }
            });
            setEvents(FormattedData);
        }
        fetchEventData();
    }, [route]);

    const handleCloseModal = () => {
        setShowModal(false); // Close the modal
        setSelectedEvent(null); // Clear the selected event
    };

    const renderEventContent = (eventInfo) => (
        <div>
            <span title={eventInfo?.event?.title}>{eventInfo?.event?.title}</span>
        </div>
    );

    const handleEventClick = (eventInfo) => {
        setSelectedEvent(eventInfo?.event);
        setShowModal(true);
    }

    const formatDate = (date) => {
        return new Date(date).toLocaleString('en-US', {
            day: 'numeric',
            month: 'short',
            year: 'numeric',
            hour: 'numeric',
            minute: '2-digit',
            hour12: true
        });
    };

    return (
        <>
            <section className="event-listing section-gap double-gap">
                <Container>
                    <Row>
                        <Col>
                            <div>
                                <FullCalendar
                                    plugins={[dayGridPlugin, timeGridPlugin]}
                                    editable={true}
                                    selectable={true}
                                    events={events}
                                    eventContent={renderEventContent}
                                    eventClick={handleEventClick}
                                />
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>



            <Modal show={showModal} onHide={handleCloseModal} className="event-modal modal-xl d-block" centered >
                <Modal.Body className="p-4 p-md-5">
                    <Button variant="link" className="custom-close-button" onClick={handleCloseModal}>
                        <i className="n-icon" data-icon="btn-icon"><MenuClose /></i>
                    </Button>
                    <Row className="align-items-center g-5 g-lg-4">
                        <Col lg={6}>
                            <div className="img-width">
                                <div className='thumbnail-container bg-transparent object-fit'>
                                    <div className='thumbnail'>
                                        <Image src={selectedEvent?.extendedProps?.image} alt={selectedEvent?.title} title={selectedEvent?.title} width="100px" height="100px" />
                                    </div>
                                    <i className="border-pattern"><Activitiesborder /></i>
                                </div>
                                <span className="star-pattern star-anim">
                                    <i className="star first">
                                        <StarIcon />
                                    </i>
                                    <i className="star second">
                                        <StarIcon />
                                    </i>
                                    <i className="star third">
                                        <StarIcon />
                                    </i>
                                </span>
                            </div>
                        </Col>
                        <Col lg={6} className="text-center">
                            <h2 className="sec-heading text-center mb-4" data-aos="fade">
                                <span className="ff-2">
                                    <span className="star">
                                        <i className="blue" data-aos="zoom-in" data-aos-duration="1500" data-aos-delay="100"><StarIcon /></i>
                                        <i className="red" data-aos="zoom-in" data-aos-duration="1500" data-aos-delay="300"><StarIcon /></i>
                                        <i className="yellow" data-aos="zoom-in" data-aos-duration="1500" data-aos-delay="100"><StarIcon /></i>
                                    </span>
                                    <span data-aos="fade" data-aos-duration="1500" data-aos-delay="500">Save the Date</span>
                                </span>
                                <span>{selectedEvent?.title}</span>
                            </h2>
                            <h6 className="date mb-3"> <span className="d-block">{formatDate(selectedEvent?.start)}</span>
                                {selectedEvent?.end && (
                                    <>
                                        <span className="my-2 d-block"> to </span>
                                        <span className="d-block">{formatDate(selectedEvent?.end)}</span>
                                    </>
                                )}</h6>
                            <div className="cms">
                                <p> {selectedEvent?.extendedProps?.description || selectedEvent?.extendedProps?.short_description}</p>
                            </div>
                            <Link to={'/' + alias?.route + '/' + selectedEvent?.extendedProps?.alias} className="btn btn-primary mt-4 mt-md-5" title="Go to event">
                                Go to event<BtnArrow />
                            </Link>
                        </Col>
                    </Row>

                </Modal.Body>
            </Modal>

        </>
    )
}

export default EventCalendar;